<template>
  <div id="app">
    <router-view />
  </div>
</template>
<style lang="scss">
#nprogress .bar {
      background: red !important; //自定义颜色
    }
.el-table--border td {
  border-right: none !important;
}
.el-card__header {
  color: #4287b9 !important;
  border-color: #4287b9 !important;
  box-sizing: border-box;
  padding: 10px 0;
  margin: 0 10px;
  line-height: 30px;
}

.splitter-pane-resizer {
  background-color: #ffffff !important;
}
.el-drawer__header{
   font-size: 20px;
   color: #000;
   background: #f5f5f5;
   margin-bottom: 20px;
    padding: 20px;

}
.el-table--enable-row-hover .el-table__body tr:hover > td{
  background-color: none;
}
.el-upload-list__item{
  width:30%;
  font-size: 16px;
}
</style>
<script>
export default {
  name: "App",
  created() {
    // console.log('app页面进来了...',this.$store.state.tagsView)
  }
};
</script>
